import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { Button as BaseButton } from '../Button';
import { Flex } from '../Flex';
import { Spacer } from '../Spacer';
import { Typography } from '../Typography';
import { notificationIcons } from './constants';
import { makeNotificationVariant } from './utils';
var Root = styled(Flex).withConfig({
  displayName: "Notification__Root",
  componentId: "sc-1inm5nu-0"
})(["user-select:none;align-items:center;", ""], makeNotificationVariant);
var Content = styled(Spacer).attrs({
  direction: 'vertical',
  space: 2,
  mr: 3,
  flex: 1
}).withConfig({
  displayName: "Notification__Content",
  componentId: "sc-1inm5nu-1"
})([""]);
var Icon = styled(Box).attrs(function (_ref) {
  var icon = _ref.icon,
      variant = _ref.variant,
      _ref$dataTest = _ref['data-test'],
      dataTest = _ref$dataTest === void 0 ? 'notification-icon' : _ref$dataTest,
      _ref$alignSelf = _ref.alignSelf,
      alignSelf = _ref$alignSelf === void 0 ? 'flex-start' : _ref$alignSelf;
  var IconComponent = notificationIcons[variant];
  var iconNode = icon && (typeof icon === 'boolean' ? /*#__PURE__*/React.createElement(IconComponent, null) : icon);
  return {
    mr: 3,
    dataTest: dataTest,
    alignSelf: alignSelf,
    children: iconNode
  };
}).withConfig({
  displayName: "Notification__Icon",
  componentId: "sc-1inm5nu-2"
})([""]);
var Heading = styled(Typography).attrs({
  textAlign: 'left',
  variant: 'body'
}).withConfig({
  displayName: "Notification__Heading",
  componentId: "sc-1inm5nu-3"
})([""]);
var Paragraph = styled(Typography).attrs({
  textAlign: 'left',
  variant: 'caption2'
}).withConfig({
  displayName: "Notification__Paragraph",
  componentId: "sc-1inm5nu-4"
})([""]);
var ButtonGroup = styled(Spacer).attrs({
  'data-test': 'notification-action-group',
  space: 2
}).withConfig({
  displayName: "Notification__ButtonGroup",
  componentId: "sc-1inm5nu-5"
})([""]);
var Button = styled(BaseButton).attrs(function (_ref2) {
  var _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? 'link' : _ref2$mode,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'black' : _ref2$variant;
  return {
    mode: mode,
    variant: variant,
    size: 'xSmall'
  };
}).withConfig({
  displayName: "Notification__Button",
  componentId: "sc-1inm5nu-6"
})([""]);
export var Notification = {
  Root: Root,
  Icon: Icon,
  Content: Content,
  Heading: Heading,
  Paragraph: Paragraph,
  ButtonGroup: ButtonGroup,
  Button: Button
};